/* EdgePro projects wall: prev/next arrows for each job's photo strip.
   Same pattern as ep-site-gallery.js, but scoped per job because a page
   carries several independent strips. Native scrollbar stays hidden in CSS;
   arrows page by one photo and disable at the ends. Touch swipe and keyboard
   scrolling untouched. Strips with nothing to scroll hide their arrows. */
(function () {
  if (window.__epPwNav) return;
  window.__epPwNav = true;

  function init(job) {
    var strip = job.querySelector('.ep-pw__strip');
    var nav = job.querySelector('[data-ep-pw-nav]');
    if (!strip || !nav) return;
    var prev = nav.querySelector('[data-ep-pw-prev]');
    var next = nav.querySelector('[data-ep-pw-next]');

    function step() {
      var item = strip.querySelector('.ep-pw__shot');
      if (!item) return strip.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(strip).columnGap) || 12;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = strip.scrollWidth - strip.clientWidth;
      if (max <= 4) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      prev.disabled = strip.scrollLeft <= 4;
      next.disabled = strip.scrollLeft >= max - 4;
    }

    prev.addEventListener('click', function () {
      strip.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      strip.scrollBy({ left: step(), behavior: 'smooth' });
    });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.ep-pw__job').forEach(init);
})();
